import { render } from "./LkView.vue?vue&type=template&id=6f10c3c1"
import script from "./LkView.vue?vue&type=script&lang=js"
export * from "./LkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__